import { render, staticRenderFns } from "./ProjectApiKeys.vue?vue&type=template&id=485cffa7&scoped=true"
import script from "./ProjectApiKeys.vue?vue&type=script&lang=js"
export * from "./ProjectApiKeys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485cffa7",
  null
  
)

export default component.exports